import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "border": "1px solid #ccc",
    "margin-top": "10px"
  }
};
import '@wangeditor/editor/dist/css/style.css';
import { onBeforeUnmount, onMounted, reactive, ref, shallowRef, watch } from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import apis from '@/api';
import { ElMessage } from "element-plus";
export default {
  __name: 'NoticeDialog',
  props: {
    title: {
      type: String,
      default: '新增/编辑公告',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    notice: {
      type: Object
    }
  },
  emits: ['submit', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const editorRef = shallowRef();
    const toolbarConfig = {};
    const editorConfig = {
      placeholder: '请输入内容...'
    };
    const mode = ref('simple');
    const formRef = ref(null);
    const elLoading = ref(false);
    const props = __props;
    const rules = {
      noticeName: [{
        required: true,
        message: "请输入公告标题",
        trigger: "blur"
      }],
      status: [{
        required: true,
        message: "请选择公告状态",
        trigger: "blur"
      }],
      startTime: [{
        required: true,
        message: "请选择公告开始时间",
        trigger: "blur"
      }],
      endTime: [{
        required: true,
        message: "请选择公告结束时间",
        trigger: "blur"
      }],
      noticeContent: [{
        required: true,
        message: "请输入公告内容",
        trigger: "blur"
      }]
    };
    watch(() => props.notice, (newVal, oldVal) => {
      data.model = JSON.parse(JSON.stringify(newVal));
    });
    const data = reactive({
      model: {
        noticeName: '',
        noticeContent: '',
        endTime: '',
        startTime: '',
        status: '1'
      }
    });
    const close = () => {
      emits('update:visible', false);
    };
    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          elLoading.value = true;
          if (data.model.id) {
            apis.updateNotice(data.model).then(res => {
              if (res.success) {
                ElMessage.success('公告修改成功！');
                emits('submit');
                emits('update:visible', false);
              } else {
                ElMessage.error(res.msg);
              }
            }).catch(err => {
              ElMessage.error('公告修改失败，请联系管理员');
            }).finally(() => {
              elLoading.value = false;
            });
          } else {
            apis.addNotice(data.model).then(res => {
              if (res.success) {
                ElMessage.success('公告添加成功！');
                emits('submit');
                emits('update:visible', false);
              } else {
                ElMessage.error(res.msg);
              }
            }).catch(err => {
              ElMessage.error('公告添加失败，请联系管理员');
            }).finally(() => {
              elLoading.value = false;
            });
          }
        }
      });
    };
    onMounted(() => {});
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });

    // 编辑器回调函数
    const handleCreated = editor => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };
    const handleChange = editor => {
      console.log('change:', editor.getHtml());
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "70%",
        top: "5vh"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("提交", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
          "label-position": "left",
          model: data.model,
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "公告标题",
                prop: "noticeName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  "show-word-limit": "",
                  maxlength: "200",
                  placeholder: "请输入公告标题",
                  modelValue: data.model.noticeName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.model.noticeName = $event),
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "公告状态",
                prop: "status"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: data.model.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.model.status = $event),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "在线",
                    value: "1"
                  }), _createVNode(_component_el_option, {
                    label: "已下线",
                    value: "0"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开始时间",
                prop: "startTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: data.model.startTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.model.startTime = $event),
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  format: "YYYY-MM-DD  HH:mm:ss",
                  type: "datetime",
                  placeholder: "选择日期时间"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "结束时间",
                prop: "endTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: data.model.endTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.model.endTime = $event),
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  format: "YYYY-MM-DD  HH:mm:ss",
                  type: "datetime",
                  placeholder: "选择日期时间"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "公告内容",
            prop: "noticeContent"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(Toolbar), {
              editor: editorRef.value,
              defaultConfig: toolbarConfig,
              mode: mode.value,
              style: {
                "border-bottom": "1px solid #ccc"
              }
            }, null, 8, ["editor", "mode"]), _createVNode(_unref(Editor), {
              defaultConfig: editorConfig,
              mode: mode.value,
              modelValue: data.model.noticeContent,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.model.noticeContent = $event),
              style: {
                "height": "200px",
                "overflow-y": "auto"
              },
              onOnCreated: handleCreated,
              onOnChange: handleChange
            }, null, 8, ["mode", "modelValue"])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])), [[_directive_loading, elLoading.value]])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};